import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumberPropType } from '../../../prop-types/intl';
import { defineMessages, FormattedMessage } from 'react-intl';

import LabeledData from '../../../components/shipment-configuration-widget/labeled-data';
import style from './package-details.module.less';

const messages = defineMessages({
  insurance: {
    description: 'packageDetails.labels.insurance',
    defaultMessage: 'Insurance',
    id: 'kJJ5Sr',
  },
  packageType: {
    description: 'packageDetails.labels.packageType',
    defaultMessage: 'Package Type',
    id: '5oQCqt',
  },
  dimensions: {
    description: 'packageDetails.labels.dimensions',
    defaultMessage: 'Dimensions',
    id: 'bvOp6v',
  },
  weight: {
    description: 'packageDetails.labels.weight',
    defaultMessage: 'Weight',
    id: 'jW0DOf',
  },
});

const PackageDetails = ({ header = '', packageType = '', weight, dimensions = '', insuranceCost = '' }) => {
  return (
    <div>
      <div className={style['package-header']}>{header}</div>
      <div className={style['package-columns']}>
        <div className={style['package-details-column']}>
          <LabeledData label={<FormattedMessage {...messages.packageType} />} value={packageType} />
          <LabeledData label={<FormattedMessage {...messages.weight} />} value={weight} />
        </div>
        <div className={style['package-details-column']}>
          <LabeledData label={<FormattedMessage {...messages.dimensions} />} value={dimensions} />
          <LabeledData label={<FormattedMessage {...messages.insurance} />} value={insuranceCost} />
        </div>
      </div>
    </div>
  );
};

PackageDetails.propTypes = {
  header: PropTypes.string,
  packageType: PropTypes.string,
  weight: FormattedNumberPropType,
  dimensions: PropTypes.string,
  insuranceCost: PropTypes.string,
};

export default PackageDetails;
